// Firestore <-> live upscale config glue. Keeps src/utils/upscaleDefaults cache in
// sync with config/upscale so the settings panel reflects saved values, and lets
// the panel write new values with no deploy (the drain reads the doc per job).
import { db } from '../firebaseConfig';
import { UPSCALE_DEFAULTS, setUpscaleConfig } from '../utils/upscaleDefaults';

const DOC = db.collection('config').doc('upscale');

// Live subscription — call once at app start. Returns the unsubscribe fn.
export function startUpscaleConfigSync() {
  return DOC.onSnapshot(
    (snap) => { setUpscaleConfig(snap.exists ? snap.data() : null); },
    () => { /* offline / perms — keep last good / defaults */ },
  );
}

export async function saveUpscaleConfig(next) {
  await DOC.set(next, { merge: true });
}

export { UPSCALE_DEFAULTS };
